import { formatDateToDayMonthYear } from '@/src/utils/dateUtil'
import { AdjustmentWarning } from '../table/adjustmentTable.types'
import { getOverlappingHolidayTimeframes } from '../table/adjustmentTable.utils'
import type { LoadPlanningMeasureModalItem } from './LoadPlanningMeasureModal.types'

export const getOverlappingHolidayTimeframesForMeasureItem = (params: {
  measureItem: LoadPlanningMeasureModalItem
  adjustments: Parameters<typeof getOverlappingHolidayTimeframes>[1] | undefined
  language: string
}) => {
  const { measureItem, adjustments, language } = params

  if (measureItem.adjustmentType === 'renewableProduction') return []

  const isAffectedByHolidayAdjustment = measureItem.warnings?.some(warning => warning === AdjustmentWarning.HOLIDAY_OVERLAP)
  if (!isAffectedByHolidayAdjustment || !adjustments || !measureItem.id || !measureItem.timeframeStart || !measureItem.timeframeEnd) {
    return []
  }

  return getOverlappingHolidayTimeframes(
    {
      id: measureItem.id,
      scope: measureItem.scope,
      locationId: measureItem.locationId,
      timeframeStart: measureItem.timeframeStart,
      timeframeEnd: measureItem.timeframeEnd,
    },
    adjustments,
    language
  )
}

export const formatOverlappingHolidayTimeframesLabel = (overlappingHolidayTimeframes: string[], language: string) => {
  if (overlappingHolidayTimeframes.length <= 1) return overlappingHolidayTimeframes[0]

  if (typeof Intl !== 'undefined' && typeof Intl.ListFormat !== 'undefined') {
    return new Intl.ListFormat(language, { style: 'long', type: 'conjunction' }).format(overlappingHolidayTimeframes)
  }

  const conjunction = language.toLowerCase().startsWith('de') ? ' und ' : ' and '
  return overlappingHolidayTimeframes.join(conjunction)
}

export const getInfoSectionLabels = (params: {
  effectiveFrom?: string
  updatedAt?: string
  effectivenessDate?: string
  language: string
}) => {
  const { effectiveFrom, updatedAt, effectivenessDate, language } = params

  return {
    updatedAtLabel: updatedAt ? formatDateToDayMonthYear(new Date(updatedAt), language) : '—',
    effectivenessDateLabel: effectivenessDate ? formatDateToDayMonthYear(new Date(effectivenessDate), language) : '—',
    effectiveFromLabel: effectiveFrom ? formatDateToDayMonthYear(new Date(effectiveFrom), language) : '—',
  }
}
